module.exports = __webpack_public_path__ + "static/media/home.7f90c37e.png";